// extracted by mini-css-extract-plugin
module.exports = {"root":"List_root__q15eY","padding":"List_padding__VkqKQ","subheader":"List_subheader__2FHNC"};